import React, { memo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Panel from "./Panel";
import Table from "./Table";
import Datagrid from "./Datagrid";
import NestedPanel from "./NestedPanel";
import FormDialogs from "../Dialogs";

function FormDialogsContainer({ formSaveHandler }) {
  const { formDialog } = useSelector((state) => state.formDialog);
  if (!formDialog.show) return null;
  return <FormDialogs handleFormSave={formSaveHandler} />;
}
FormDialogsContainer.propTypes = {
  formSaveHandler: PropTypes.func,
};
FormDialogsContainer.defaultProps = {
  formSaveHandler: undefined,
};

function Layout(props) {
  const {
    components,
    nested = false,
    handleTabChange = () => {},
    formTemplate = {},
    formSaveHandler,
    isForm = false,
  } = props;
  const tableGrids =
    components &&
    components.filter(
      (component) =>
        component.type === "table" ||
        component.type === "datagrid" ||
        component.type === "panel"
    );

  return (
    <div>
      {tableGrids.length > 0 &&
        tableGrids.map((tableGrid) => {
          if (tableGrid.type === "panel" && !nested) {
            return (
              <Panel
                handleTabChange={handleTabChange}
                key={`${tableGrid.key}-${tableGrid.title}`}
                components={tableGrid}
                formTemplate={formTemplate}
              />
            );
          }
          if (tableGrid.type === "panel" && nested) {
            return (
              <NestedPanel
                key={`${tableGrid.key}-${tableGrid.title}`}
                tableGrid={tableGrid}
              />
            );
          }
          if (tableGrid.type === "table") {
            return <Table key={tableGrid.key} components={tableGrid} />;
          }
          if (tableGrid.type === "datagrid") {
            return <Datagrid key={tableGrid.key} gridItem={tableGrid} />;
          }
          return <div>Invalid element</div>;
        })}
      {isForm && <FormDialogsContainer formSaveHandler={formSaveHandler} />}
    </div>
  );
}
Layout.whyDidYouRender = true;
Layout.propTypes = {
  formTemplate: PropTypes.shape({}),
  handleTabChange: PropTypes.func,
  components: PropTypes.oneOfType([PropTypes.array]).isRequired,
  nested: PropTypes.bool,
  isForm: PropTypes.bool,
  formSaveHandler: PropTypes.func,
};
Layout.defaultProps = {
  nested: false,
  isForm: false,
  formTemplate: {},
  handleTabChange: () => {},
  formSaveHandler: undefined,
};
export default memo(Layout);
